// removed by extract-text-webpack-plugin
module.exports = {"underline":"CwLabel-underline","clickable":"CwLabel-clickable","bold":"CwLabel-bold","italic":"CwLabel-italic","invalid":"CwLabel-invalid","disabled":"CwLabel-disabled","podLabel":"CwLabel-podLabel","link":"CwLabel-link"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwlabel/CwLabel.scss
// module id = 372
// module chunks = 0